import { TAB_COUNTRY } from '../../views/accounts/overview';

export function fsHeatmapDirective(userService, arsMainDependencies) {
	return {
		scope: {
			worldmapdata: '=',
            tabName: '='
		},
		replace: true,
		template: '<div class="vmap"></div>',
		link: function(scope, element, attrs) {
            const negative = {}, positive = {};
            scope.worldmapdata.forEach((countrysummary) => {
                const value = countrysummary.consolidatedBalance.amount;
                const key = countrysummary.code;
                if(value < 0) {
                    negative[key] = value;
                } else {
                    positive[key] = value;
                }
            });

            $(element).css({ height: (attrs.height ? attrs.height : 180 + 'px') });

            $(element).vectorMap({
					map: 'world_mill',
					regionStyle: {
						initial: {
							fill: '#d6d9dc'
						},
						selected: {
							fill: '#5a6a7d'
						},
                        hover: {
                            fill: '#FEC057',
                            "fill-opacity": 1
                        }
					},
					series: {
						regions: [
							{
								scale: ['#DAE9F9', '#056ED5'],
								attribute: 'fill',
								values: positive,
								normalizeFunction: 'linear'
							},
							{
								scale: ['#F26161', '#FDE7E7'],
								attribute: 'fill',
								values: negative,
								normalizeFunction: 'linear'
							}
						]
					},
					backgroundColor: 'transparent',
					regionsSelectable: true,
					onRegionClick: function(e, regionCode) {
						const map = $(element).vectorMap('get', 'mapObject');
						map.clearSelectedRegions();
                        // broadcasts filtering to accountsFilter.directive.js or to the group display

                        const country = scope.worldmapdata.filter(it => it.code == regionCode &&
                            (it.kind == 'country' || it.code != null));

                        if (_.isNil(country[0])) {
                            userService.fsMainDependencies.toast.toaster.warning(
                                userService.fsMainDependencies.$translate.instant("NOT_FOUND_MESSAGE"));
                        } else {
                            if (scope.tabName === TAB_COUNTRY) {
                                userService.fsMainDependencies.$rootScope.$broadcast('expandGroupData', country[0]);
                                userService.fsMainDependencies.$rootScope.$apply(); // ARSWEB-389: the view is not refreshed!
                            } else {
                                map.tip.hide();
                                const moveToHash = () => arsMainDependencies.$state.go("app.accountsByCountry",
                                    { 'anchorName': country[0]});
                                moveToHash();
                            }
                        }
					},
                    onRegionTipShow: function(e, label, code) {
                        // display latest data on the scope, for latest consolidationCurrency
                        let val = 0;
                        let fractionDigits = 2;
                        scope.worldmapdata.forEach((countrysummary) => {
                            const value = countrysummary.consolidatedBalance.amount;
                            const key = countrysummary.code;
                            if(key === code) {
                                val = value
                            }
                            if(value < 0) {
                                negative[key] = value;
                            } else {
                                positive[key] = value;
                            }
                            fractionDigits = countrysummary.consolidatedBalance.fractionDigits;
                        });
                        const map = $(element).vectorMap('get', 'mapObject');

                        label.html( map.getRegionName(code) + ': <br>' + userService.filterFormatter('fsNumber')(val, fractionDigits) +
                            ' <i>'+ scope.worldmapdata[0].consolidationCurrency + '</icon>');
                    }
				});
        }
	};
}
